import { ResponsiveLine } from '@nivo/line'

const CustomLineChart = ({ data, yFormat, axisLeftFormat, yScaleMin = 0, height = 300 }) => (
	<div style={{ height, overflow: 'hidden' }}>
		<ResponsiveLine
			data={data}
			colors={['#f46d25', '#808080']}
			margin={{ top: 50, right: 50, bottom: 50, left: 50 }}
			yFormat={yFormat || ' >-.2f'}
			yScale={{ type: 'linear', min: yScaleMin, max: 'auto' }}
			axisTop={null}
			axisRight={null}
			axisLeft={axisLeftFormat ? { format: axisLeftFormat } : undefined}
			enableArea={true}
			enableSlices="x"
			pointSize={10}
			pointColor={{ theme: 'background' }}
			pointBorderWidth={2}
			pointBorderColor={{ from: 'serieColor' }}
			pointLabel="data.yFormatted"
			pointLabelYOffset={-12}
			enableTouchCrosshair={true}
			useMesh={true}
			enableGridX={false}
		/>
	</div>
)

export default CustomLineChart
